// @flow strict

import * as React from 'react';
//$FlowFixMe[untyped-import]
import {ReactQueryDevtools} from '@tanstack/react-query-devtools';

import css from './tanstack-query-devtools.css';


const TanstackQueryDevtools = (): React.Node => (
  <div className={css.container}>
    <ReactQueryDevtools initialIsOpen={false} buttonPosition="bottom-left" />
  </div>
);

export default TanstackQueryDevtools;
